import Head from "next/head";

import DocumentToolKitMain from "@/components/document-toolkit/document-toolkit-main";

import SeoMetaData from "@/components/utils/seo-metadata";
import seoData from "@/data/seo/page-data.json";

export default function DocumentToolKit() {
  return (
    <>
      <Head>
        <title>{seoData.DOCUMENT_TOOLKIT.title}</title>
        <SeoMetaData data={seoData.DOCUMENT_TOOLKIT} />
      </Head>

      <DocumentToolKitMain />
    </>
  );
}
